import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FiX, FiFacebook, FiInstagram, FiYoutube } from "react-icons/fi";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { RiMenu3Fill } from "react-icons/ri";

const NavbarThree = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 z-50 w-full max-w-2xl font-signika">
      {/* ================= TOPBAR ================= */}
      {/* TOPBAR */}
      <div className="hidden md:flex justify-between items-center bg-primary2 text-white text-sm px-6 py-2">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <BsTelephoneFill />
            +6285655556864
          </div>
          <div className="flex items-center gap-2">
            <MdEmail />
            admin@patunganindonesia.com
          </div>
        </div>

        <div className="flex items-center gap-3">
          <span className="mr-2">Follow Us On:</span>
          <FiFacebook />
          <FiInstagram />
          <FiYoutube />
        </div>
      </div>

      {/* MAIN NAV */}
      <div className="bg-white shadow-sm">
        <div className="px-6 h-[74px] flex items-center justify-between">
          <NavLink to="/">
            <img src="/images/logo.png" className="h-10" alt="" />
          </NavLink>

          <div className="hidden lg:flex items-center gap-3">
            <NavLink to="https://patunganindonesia.online/login/inspirator" className="bg-secondary text-white px-6 py-2.5 rounded-full font-semibold">
              Masuk
            </NavLink>

            <NavLink to="https://patunganindonesia.online/inspirator/register" className="border border-secondary text-secondary px-6 py-2.5 rounded-full font-semibold">
              Daftar
            </NavLink>
          </div>
          {/* HAMBURGER */}
          <button className="lg:hidden" onClick={() => setOpen(!open)}>
            {open ? <FiX size={28} /> : <RiMenu3Fill size={28} />}
          </button>
        </div>
      </div>

      {/* ================= MOBILE MENU ================= */}
      <div className={`lg:hidden fixed top-[74px] left-0 w-full bg-white shadow-md transition-all duration-300 ${open ? "max-h-screen py-6" : "max-h-0 overflow-hidden"}`}>
        <div className="max-w-2xl mx-auto flex flex-col items-center gap-5 text-gray-700 font-medium">
          <NavLink to="https://patunganindonesia.online/login/inspirator" className="text-primary2 px-6 py-2.5 rounded-full font-semibold">
            Beranda
          </NavLink>

          <NavLink to="/login" className="bg-secondary text-white px-6 py-2 rounded-full" onClick={() => setOpen(false)}>
            Masuk
          </NavLink>

          <NavLink
            to="https://patunganindonesia.online/inspirator/register"
            className="border border-secondary text-secondary hover:bg-green-800 hover:text-white px-6 py-2.5 rounded-full font-semibold transition"
            onClick={() => setOpen(false)}>
            Daftar
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default NavbarThree;
